import { render, staticRenderFns } from "./k-v-panel.vue?vue&type=template&id=d8c4e77e&scoped=true&"
import script from "./k-v-panel.vue?vue&type=script&lang=js&"
export * from "./k-v-panel.vue?vue&type=script&lang=js&"
import style0 from "./k-v-panel.vue?vue&type=style&index=0&id=d8c4e77e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c4e77e",
  null
  
)

export default component.exports